import {MainVideoState} from "../definitions/MainVideoState";

export const mouseActivity = (state: MainVideoState) => {
    state.projectState.showFullScreenControlBar = true;
};
